import { Box, Typography } from '@mui/material';
import type { ColumnDef } from '../../../shared/components/SortableTable';
import type { ActionLogEntry } from '../../../types/backend';
import TimeCell from './TimeCell';
import { opsItemKind, KIND_META, severityMeta, statusLabel, KindIcon } from '../utils/opsitemDisplay';

export const timeColumn: ColumnDef<ActionLogEntry> = {
  key: 'created_at',
  label: 'Time',
  sortValue: (e) => new Date(e.created_at).getTime(),
  render: (e) => <TimeCell iso={e.created_at} />,
};

export const kindColumn: ColumnDef<ActionLogEntry> = {
  key: 'kind',
  label: 'Kind',
  sortValue: (e) => opsItemKind(e),
  render: (e) => {
    const kind = opsItemKind(e);
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <KindIcon kind={kind} size={16} />
        <Typography variant="body2">{KIND_META[kind].label}</Typography>
      </Box>
    );
  },
};

export const titleColumn: ColumnDef<ActionLogEntry> = {
  key: 'title',
  label: 'Action log item',
  sortValue: (e) => e.title,
  render: (e) => (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="body2" noWrap title={e.title}>
        {e.title}
      </Typography>
      {e.detail_type && (
        <Typography noWrap sx={{ fontSize: 11.5, color: 'text.secondary' }}>
          {e.detail_type}
        </Typography>
      )}
    </Box>
  ),
};

export const ruleNameColumn: ColumnDef<ActionLogEntry> = {
  key: 'rule_name',
  label: 'Rule',
  sortValue: (e) => e.rule_name || '',
  render: (e) => (
    <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
      {e.rule_name || '—'}
    </Typography>
  ),
};

export const severityColumn: ColumnDef<ActionLogEntry> = {
  key: 'severity',
  label: 'Severity',
  sortValue: (e) => e.severity,
  render: (e) => <Typography variant="body2">{severityMeta(e.severity).label}</Typography>,
};

export const statusColumn: ColumnDef<ActionLogEntry> = {
  key: 'status',
  label: 'Status',
  sortValue: (e) => e.status,
  render: (e) => <Typography variant="body2">{statusLabel(e.status)}</Typography>,
};

export const ACTION_LOG_COLUMNS: ColumnDef<ActionLogEntry>[] = [
  timeColumn, kindColumn, titleColumn, ruleNameColumn, severityColumn, statusColumn,
];
